export default {
    configuration: false,
    searchList: {
        fieldTrim: true,
        searchTxt: [
            {
                name: '配置类型',
                value: 'riskType',
                unfold: true,
                type: 'select',
                optionNum: 'OTP_RISK_TYPE',
                options: [],
                span: 4
            },
            {
                name: '参数类型',
                value: 'riskReason',
                unfold: true,
                type: 'select',
                optionNum: 'OTP_RISK_REASON',
                options: [],
                span: 4
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 110,
        selectBtn: true,
        columns: [
            {
                label: '序号',
                prop: 'tableIndex'
            },
            {
                label: '配置类型',
                prop: 'riskType',
                type: 'select',
                optionNum: 'OTP_RISK_TYPE',
                options: [],
                sort: true
            },
            {
                label: '参数类型',
                prop: 'riskReason',
                type: 'select',
                optionNum: 'OTP_RISK_REASON',
                options: [],
                sort: true
            },
            {
                label: '风控维度',
                prop: 'riskLevel',
                type: 'select',
                optionNum: 'OTP_RISK_LEVEL',
                options: [],
                sort: true
            },
            {
                label: '是否推送BMS强控',
                prop: 'forceFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'true', label: '是' },
                    { value: 'false', label: '否' }
                ],
                sort: true
            },
            {
                label: '备注',
                prop: 'remark',
                sort: true
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true
            },
            {
                label: '修改人',
                prop: 'updateUserName',
                sort: true
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '修改',
                size: 'small',
                event: 'edit',
                ifHas: 'riskControlConfig-edit'
            },
            {
                type: 'text',
                label: '删除',
                size: 'small',
                event: 'del',
                ifHas: 'riskControlConfig-delete'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: []
};
